import * as React from 'react';

import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import ChevronRight from '@material-ui/icons/ChevronRight';
import Link from 'ha/ui/next/Link';
import Track from 'ha/components/track/SmartTrack';
import { Typography } from 'ha/ui/next/Typography';

const styles = (t: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
  });

interface Props {
  name: string;
  path?: string;
  renderAsLink?: boolean;
  skipLangFormat?: boolean;
  withoutSeparator?: boolean;
  dataTestLocator?: string;
}

const BreadcrumbItem: React.SFC<Props & WithStyles<typeof styles>> = ({
  name,
  path = null,
  renderAsLink = false,
  withoutSeparator = false,
  classes,
  dataTestLocator,
}) => {
  return renderAsLink && path ? (
    <Track name="Clicked Breadcrumb in header" type="link">
      <div className={classes.container}>
        {!withoutSeparator && <ChevronRight color="primary" />}

        <Link to={path} data-test-locator={dataTestLocator}>
          {name}
        </Link>
      </div>
    </Track>
  ) : (
    <div className={classes.container}>
      {!withoutSeparator && <ChevronRight color="primary" />}
      <Typography.Paragraph color="muted" data-test-locator={dataTestLocator}>
        {name}
      </Typography.Paragraph>
    </div>
  );
};

export default withStyles(styles)(BreadcrumbItem);
